import { ContentConsumerProps, ContentConsumerType, useContent } from '@qbe/dfc-content';
import cmsProvider from '../resources/cmsProvider';

const useContentComplaintPartners = useContent as ({ basePath, context, state, tokens }: ContentConsumerProps) => {
  getTextContent: <P extends keyof typeof cmsProvider>(itemPath: P) => (typeof cmsProvider)[P];
  getJSXContent: <P extends keyof typeof cmsProvider>(itemPath: P) => (typeof cmsProvider)[P];
} & ContentConsumerType;

export { useContentComplaintPartners };
